// extracted by mini-css-extract-plugin
export default {"layout":"v4hr6yi5NZ4lmrk5rRnB","content":"dY_QyCEzEUb_Gdy0UKfu","header":"G6kEMO0_gQ7G5z8J6O6w","language":"dy5ESnHbsWLR6TvSKjHQ"};